import { useNavigate } from "react-router-dom";
import { ROUTES } from "../constants/routes";


const CreateHostOrgDescComponent: React.FC<{}> = () => {

const navigate = useNavigate();
return (
    <div>
<div style={styles.splitPanel}>
                        {/* <div className='card' style={styles.panel}>
                            <h1>Create an Organization</h1>
                            <h2>I want to manage people attending an event</h2>
                            <p><em>Example: Whether you're a director or teacher keeping track of your students, a sports team attending a competition, or a youth group attending a workshop, an organization profile helps keep everything organized and seamless.</em></p>
                            <h4>With an organization, you can:</h4>
                            <div style={styles.contentContainer}>
                                <p><strong>Track your registrants:</strong> Keep a detailed list of all the people attending your events, whether it’s a group of students, a team, or any collective.</p>
                                <p><strong>Join events:</strong> Register your group for various events, whether they are conferences, sports competitions, music festivals, or workshops.</p>
                                <p><strong>View attending events:</strong> See a list of all events your group is invited to and attending, including schedules and locations, all in one place.</p>
                                <p><strong>Monitor group billing:</strong> View and manage your organization’s billing for all registered events, ensuring everything is up to date.</p>
                                {/* <p><strong>Communicate with registrants:</strong> Send messages or updates to all members of your organization regarding upcoming events, changes, or important information.</p> */}


                               {/*} <h4>Get Started</h4>
                                <p>Creating an organization lets you manage your group’s attendance, track your members, and stay on top of event schedules and billing. Once set up, you can efficiently manage your entire team’s or class’s participation.</p>
                            </div>
                            <button style={styles.createButton} onClick={() => navigate(ROUTES.CREATE_ORGANIZATION)}>Create Organization</button>
                        </div> */}

                        <div className='card' style={styles.panel}>
                            <h1>Create a Host</h1>
                            <h2>I want to host an event</h2>
                            <p><em>Example: Whether you're hosting a wedding, conference, a webinar, a community event, a sporting event, a music competition, or a band camp, a host will give you all the tools you need to manage your attendees and streamline the process.</em></p>
                            <h4>With a host, you can:</h4>
                            <div style={styles.contentContainer}>
                                <p><strong>Create and manage events:</strong> Plan, schedule, and manage all your events in one place.</p>
                                <p><strong>Manage incoming registrants:</strong> Keep track of registrations and organize attendee data effortlessly.</p>
                                <p><strong>Keep track of billing:</strong> Streamline your billing process, track payments, and manage invoices with ease.</p>
                                <p><strong>Evaluate incoming registrants:</strong> Assess your registrants based on predefined criteria or custom evaluations.</p>
                                <p><strong>Organize registrants into groups:</strong> Group your registrants based on interest, location, or any custom tags.</p>


                                <h4>Get Started</h4>
                                <p>Creating a host allows you to take control of your events. Once you’ve set up your host, you’ll be able to leverage all the tools necessary to run a successful event.</p>
                            </div>
                            <button style={styles.createButton} onClick={() => navigate(ROUTES.CREATE_HOST)}>Create Host</button>
                        </div>
                    </div>
                    <div className='bottomButtons'><button type='button' className='cancelButton' onClick={() => navigate(ROUTES.CHOOSE_HOST)}>Back</button></div>
                    </div>
                    );

};

const styles = {
    dashboardContainer: {
        display: 'flex',
    },
    contentContainer: {
        padding: '0px',
        flex: 1,
    },
    splitPanel: {
        display: 'flex',
        justifyContent: 'center',
    },
    panel: {
        width: '100%',
        minWidth: '400px',
        padding: '20px',
        border: '1px solid #ccc',
        placeItems: 'center',
        maxWidth: '600px'
    },
    createButton: {
        width: '100%',
        padding: '10px',
        marginTop: '20px',
        cursor: 'pointer',
        fontSize: '20px',
        minWidth: '400px',
        minHeight: '50px'
    }
};

export default CreateHostOrgDescComponent;
